import { Component } from '@angular/core';

import { AnswerTypeComponent } from '../answer-type.component';

@Component({
    selector: 'answer-numeric-textbox',
    templateUrl: './answer-numeric-textbox.component.html',
    standalone: false
})
export class AnswerNumericTextboxComponent extends AnswerTypeComponent {

}
